export default {
  localWeather: {
    code: {
      '1': '北海道宗谷地方',
      '2': '北海道上川地方',
      '3': '北海道留萌地方',
      '4': '北海道石狩地方',
      '5': '北海道空知地方',
      '6': '北海道後志地方',
      '7': '北海道網走地方',
      '8': '北海道北見地方',
      '9': '北海道紋別地方',
      '10': '北海道根室地方',
      '11': '北海道釧路地方',
      '12': '北海道十勝地方',
      '13': '北海道胆振地方',
      '14': '北海道日高地方',
      '15': '北海道渡島地方',
      '16': '北海道檜山地方',
      '17': '青森県津軽',
      '18': '青森県下北',
      '19': '青森県三八上北',
      '20': '秋田県沿岸',
      '21': '秋田県内陸',
      '22': '岩手県内陸',
      '23': '岩手県沿岸北部',
      '24': '岩手県沿岸南部',
      '25': '宮城県東部',
      '26': '宮城県西部',
      '27': '山形県村山',
      '28': '山形県置賜',
      '29': '山形県庄内',
      '30': '山形県最上',
      '31': '福島県中通り',
      '32': '福島県浜通り',
      '33': '福島県会津',
      '34': '茨城県北部',
      '35': '茨城県南部',
      '36': '栃木県南部',
      '37': '栃木県北部',
      '38': '群馬県南部',
      '39': '群馬県北部',
      '40': '埼玉県南部',
      '41': '埼玉県北部',
      '42': '埼玉県秩父地方',
      '43': '東京都東京地方',
      '44': '東京都伊豆諸島北部',
      '45': '東京都伊豆諸島南部',
      '46': '東京都小笠原諸島',
      '47': '千葉県北西部',
      '48': '千葉県北東部',
      '49': '千葉県県南部',
      '50': '神奈川県東部',
      '51': '神奈川県西部',
      '52': '長野県北部',
      '53': '長野県中部',
      '54': '長野県南部',
      '55': '山梨県中・西部',
      '56': '山梨県東部・富士五湖',
      '57': '静岡県中部',
      '58': '静岡県伊豆',
      '59': '静岡県東部',
      '60': '静岡県西部',
      '61': '愛知県西部',
      '62': '愛知県東部',
      '63': '岐阜県美濃地方',
      '64': '岐阜県飛騨地方',
      '65': '三重県北中部',
      '66': '三重県南部',
      '67': '新潟県下越',
      '68': '新潟県中越',
      '69': '新潟県上越',
      '70': '新潟県佐渡',
      '71': '富山県東部',
      '72': '富山県西部',
      '73': '石川県加賀',
      '74': '石川県能登',
      '75': '福井県嶺北',
      '76': '福井県嶺南',
      '77': '滋賀県南部',
      '78': '滋賀県北部',
      '79': '京都府南部',
      '80': '京都府北部',
      '81': '大阪府大阪府',
      '82': '兵庫県南部',
      '83': '兵庫県北部',
      '84': '奈良県北部',
      '85': '奈良県南部',
      '86': '和歌山県北部',
      '87': '和歌山県南部',
      '88': '岡山県南部',
      '89': '岡山県北部',
      '90': '広島県南部',
      '91': '広島県北部',
      '92': '島根県東部',
      '93': '島根県西部',
      '94': '島根県隠岐',
      '95': '鳥取県東部',
      '96': '鳥取県中・西部',
      '97': '徳島県北部',
      '98': '徳島県南部',
      '99': '香川県香川県',
      '100': '愛媛県中予',
      '101': '愛媛県東予',
      '102': '愛媛県南予',
      '103': '高知県中部',
      '104': '高知県東部',
      '105': '高知県西部',
      '106': '山口県西部',
      '107': '山口県中部',
      '108': '山口県東部',
      '109': '山口県北部',
      '110': '福岡県福岡地方',
      '111': '福岡県北九州地方',
      '112': '福岡県筑豊地方',
      '113': '福岡県筑後地方',
      '114': '大分県中部',
      '115': '大分県北部',
      '116': '大分県西部',
      '117': '大分県南部',
      '118': '長崎県南部',
      '119': '長崎県北部',
      '120': '長崎県壱岐・対馬',
      '121': '長崎県五島',
      '122': '佐賀県南部',
      '123': '佐賀県北部',
      '124': '熊本県熊本地方',
      '125': '熊本県阿蘇地方',
      '126': '熊本県天草・芦北地方',
      '127': '熊本県球磨地方',
      '128': '宮崎県南部平野部',
      '129': '宮崎県北部平野部',
      '130': '宮崎県南部山沿い',
      '131': '宮崎県北部山沿い',
      '132': '鹿児島県奄美地方',
      '133': '鹿児島県薩摩地方',
      '134': '鹿児島県大隅地方',
      '135': '鹿児島県種子島・屋久島地方',
      '136': '沖縄県本島中南部',
      '137': '沖縄県本島北部',
      '138': '沖縄県久米島',
      '139': '沖縄県大東島地方',
      '140': '沖縄県宮古島地方',
      '141': '沖縄県石垣島地方',
      '142': '沖縄県与那国島地方'
    },
    point: [
      {
        prefecture: '北海道',
        list: {
          '1': '宗谷地方',
          '2': '上川地方',
          '3': '留萌地方',
          '4': '石狩地方',
          '5': '空知地方',
          '6': '後志地方',
          '7': '網走地方',
          '8': '北見地方',
          '9': '紋別地方',
          '10': '根室地方',
          '11': '釧路地方',
          '12': '十勝地方',
          '13': '胆振地方',
          '14': '日高地方',
          '15': '渡島地方',
          '16': '檜山地方'
        }
      },
      {
        prefecture: '青森県',
        list: {
          '17': '津軽',
          '18': '下北',
          '19': '三八上北'
        }
      },
      {
        prefecture: '秋田県',
        list: {
          '20': '沿岸',
          '21': '内陸'
        }
      },
      {
        prefecture: '岩手県',
        list: {
          '22': '内陸',
          '23': '沿岸北部',
          '24': '沿岸南部'
        }
      },
      {
        prefecture: '宮城県',
        list: {
          '25': '東部',
          '26': '西部'
        }
      },
      {
        prefecture: '山形県',
        list: {
          '27': '村山',
          '28': '置賜',
          '29': '庄内',
          '30': '最上'
        }
      },
      {
        prefecture: '福島県',
        list: {
          '31': '中通り',
          '32': '浜通り',
          '33': '会津'
        }
      },
      {
        prefecture: '茨城県',
        list: {
          '34': '北部',
          '35': '南部'
        }
      },
      {
        prefecture: '栃木県',
        list: {
          '36': '南部',
          '37': '北部'
        }
      },
      {
        prefecture: '群馬県',
        list: {
          '38': '南部',
          '39': '北部'
        }
      },
      {
        prefecture: '埼玉県',
        list: {
          '40': '南部',
          '41': '北部',
          '42': '秩父地方'
        }
      },
      {
        prefecture: '東京都',
        list: {
          '43': '東京地方',
          '44': '伊豆諸島北部',
          '45': '伊豆諸島南部',
          '46': '小笠原諸島'
        }
      },
      {
        prefecture: '千葉県',
        list: {
          '47': '北西部',
          '48': '北東部',
          '49': '南部'
        }
      },
      {
        prefecture: '神奈川県',
        list: {
          '50': '東部',
          '51': '西部'
        }
      },
      {
        prefecture: '長野県',
        list: {
          '52': '北部',
          '53': '中部',
          '54': '南部'
        }
      },
      {
        prefecture: '山梨県',
        list: {
          '55': '中・西部',
          '56': '東部・富士五湖'
        }
      },
      {
        prefecture: '静岡県',
        list: {
          '57': '中部',
          '58': '伊豆',
          '59': '東部',
          '60': '西部'
        }
      },
      {
        prefecture: '愛知県',
        list: {
          '61': '西部',
          '62': '東部'
        }
      },
      {
        prefecture: '岐阜県',
        list: {
          '63': '美濃地方',
          '64': '飛騨地方'
        }
      },
      {
        prefecture: '三重県',
        list: {
          '65': '北中部',
          '66': '南部'
        }
      },
      {
        prefecture: '新潟県',
        list: {
          '67': '下越',
          '68': '中越',
          '69': '上越',
          '70': '佐渡'
        }
      },
      {
        prefecture: '富山県',
        list: {
          '71': '東部',
          '72': '西部'
        }
      },
      {
        prefecture: '石川県',
        list: {
          '73': '加賀',
          '74': '能登'
        }
      },
      {
        prefecture: '福井県',
        list: {
          '75': '嶺北',
          '76': '嶺南'
        }
      },
      {
        prefecture: '滋賀県',
        list: {
          '77': '南部',
          '78': '北部'
        }
      },
      {
        prefecture: '京都府',
        list: {
          '79': '南部',
          '80': '北部'
        }
      },
      {
        prefecture: '大阪府',
        list: {
          '81': '大阪府'
        }
      },
      {
        prefecture: '兵庫県',
        list: {
          '82': '南部',
          '83': '北部'
        }
      },
      {
        prefecture: '奈良県',
        list: {
          '84': '北部',
          '85': '南部'
        }
      },
      {
        prefecture: '和歌山県',
        list: {
          '86': '北部',
          '87': '南部'
        }
      },
      {
        prefecture: '岡山県',
        list: {
          '88': '南部',
          '89': '北部'
        }
      },
      {
        prefecture: '広島県',
        list: {
          '90': '南部',
          '91': '北部'
        }
      },
      {
        prefecture: '島根県',
        list: {
          '92': '東部',
          '93': '西部',
          '94': '隠岐'
        }
      },
      {
        prefecture: '鳥取県',
        list: {
          '95': '東部',
          '96': '中・西部'
        }
      },
      {
        prefecture: '徳島県',
        list: {
          '97': '北部',
          '98': '南部'
        }
      },
      {
        prefecture: '香川県',
        list: {
          '99': '香川県'
        }
      },
      {
        prefecture: '愛媛県',
        list: {
          '100': '中予',
          '101': '東予',
          '102': '南予'
        }
      },
      {
        prefecture: '高知県',
        list: {
          '103': '中部',
          '104': '東部',
          '105': '西部'
        }
      },
      {
        prefecture: '山口県',
        list: {
          '106': '西部',
          '107': '中部',
          '108': '東部',
          '109': '北部'
        }
      },
      {
        prefecture: '福岡県',
        list: {
          '110': '福岡地方',
          '111': '北九州地方',
          '112': '筑豊地方',
          '113': '筑後地方'
        }
      },
      {
        prefecture: '大分県',
        list: {
          '114': '中部',
          '115': '北部',
          '116': '西部',
          '117': '南部'
        }
      },
      {
        prefecture: '長崎県',
        list: {
          '118': '南部',
          '119': '北部',
          '120': '壱岐・対馬',
          '121': '五島'
        }
      },
      {
        prefecture: '佐賀県',
        list: {
          '122': '南部',
          '123': '北部'
        }
      },
      {
        prefecture: '熊本県',
        list: {
          '124': '熊本地方',
          '125': '阿蘇地方',
          '126': '天草・芦北地方',
          '127': '球磨地方'
        }
      },
      {
        prefecture: '宮崎県',
        list: {
          '128': '南部平野部',
          '129': '北部平野部',
          '130': '南部山沿い',
          '131': '北部山沿い'
        }
      },
      {
        prefecture: '鹿児島県',
        list: {
          '132': '奄美地方',
          '133': '薩摩地方',
          '134': '大隅地方',
          '135': '種子島・屋久島地方'
        }
      },
      {
        prefecture: '沖縄県',
        list: {
          '136': '本島中南部',
          '137': '本島北部',
          '138': '久米島',
          '139': '大東島地方',
          '140': '宮古島地方',
          '141': '石垣島地方',
          '142': '与那国島地方'
        }
      }
    ]
  }
}
